import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiGetRegularTicketsRequest extends ApiRequestor {
  async $get(organizationId, matchId) {
    const params = { organizationId, matchId }
    return this.$http('GET', `tickets/purchasable`, {params})
  }
}
